import { useMemo } from 'react';

import {
  GetTeamBillingQuery,
  ProjectMemberRole,
  Team,
  useGetTeamBillingQuery,
} from '@graphql/generated';

export type TeamBilling = NonNullable<GetTeamBillingQuery['listTeams']>[number];

interface TeamBillingFromQueryProps {
  role?: ProjectMemberRole;
  includePending?: boolean;
  skip?: boolean;
}

/**
 * Retrieves billing data (product, invoices, subscriptionDetails) for all
 * teams, keyed by team id. Billing fields are split out of listTeams
 * (TA-9873) so they are only fetched on payment pages.
 */
export const useTeamBillingFromQuery = (props?: TeamBillingFromQueryProps) => {
  const {
    data: { listTeams } = {},
    loading,
    error,
    refetch,
  } = useGetTeamBillingQuery({
    variables: {
      role: props?.role,
      includePending: props?.includePending || false,
    },
    fetchPolicy: 'cache-and-network',
    skip: props?.skip,
  });

  const billingByTeamId = useMemo(() => {
    const byId: Record<Team['id'], TeamBilling> = {};
    (listTeams || []).forEach((team) => {
      if (team?.id) {
        byId[team.id] = team;
      }
    });
    return byId;
  }, [listTeams]);

  return { billingByTeamId, loading, error, refetch };
};
